/**
 * Numerous error handling functions
 */

let handleError = console.error;

class PublicError extends Error {
	constructor(...params) {
		super(...params);
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, PublicError);
		}
		this.name = 'PublicError';
	}
}

class SilentError extends Error {
	constructor(...params) {
		super(...params);
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, PublicError);
		}
		this.name = 'SilentError';
	}
}

const catchErrors = fn => {
	return function (...params) {
		try {
			fn(...params);
		} catch (error) {
			handleError(error);
		}
	};
};

const initErrors = handler => {
	handleError = handler;
};

export { PublicError, SilentError, handleError, catchErrors, initErrors };
